import { Component, input, inject, signal, computed } from '@angular/core';

import { CommonModule } from '@angular/common';

import { TeamLogoLookupPipe } from '../shared/team-logo-lookup.pipe';
import { TimespanMsPipe, TimespanShortPipe } from '../shared/time-span.pipe';
import { TimingTowerDrawerComponent } from './timing-tower-drawer.component';
import { PositionChangeIndicatorComponent } from './position-change-indicator.component';

import { ISessionEntry } from './IRaceTiming';
import { RaceSessionService } from './race-session.service';
import { TimingTowerService } from './timing-tower.service';

@Component({
	selector: 'vb-lxp-timing-tower-full',
	imports: [
		CommonModule,
		TeamLogoLookupPipe,
		TimespanMsPipe,
		TimespanShortPipe,
		TimingTowerDrawerComponent,
		PositionChangeIndicatorComponent,
	],
	templateUrl: './timing-tower-full.component.html',
	styleUrl: './timing-tower-full.component.css',
})
export class TimingTowerFullComponent {
	public activeClass = input('');
	public activeNumberClass = input('');
	public selectedClasses = input<string[]>([]);

	public raceSessionService = inject(RaceSessionService);
	public timingTowerService = inject(TimingTowerService);
	public positionChangeStateByNumber = this.raceSessionService.positionChangeStateByNumber;

	public expandedTeamNumber = signal<string | null>(null);

	public teams = computed(() => {
		const selectedClasses = this.selectedClasses();
		const entries = this.raceSessionService.raceTeamsPosition();
		
		return entries.filter((entry) => {
			return selectedClasses.length === 0 || selectedClasses.includes(entry.class);
		});
	});

	public toggleTeamSelection(team: ISessionEntry) {
		this.timingTowerService.toggleActive(team.number);
	}

	public toggleDrawer(team: any, event: MouseEvent): void {
		event.stopPropagation();
		const selectedNumber = team?.number ?? null;
		this.expandedTeamNumber.update((current) =>
			current === selectedNumber ? null : selectedNumber,
		);
	}

	public isDrawerOpen(team: any): boolean {
		return this.expandedTeamNumber() === team?.number;
	}

	public trackByFn(index: number, item: any): string {
		return item.number; // assuming unique team number
	}
}
